module.exports = __webpack_public_path__ + "img/noAlarm.16c3c59b.png";